import { isWeChat } from "../help/wechat";
import { URLS } from "fire-wind-water";
import { user } from "../user";

function auth() {
  const config: { [label: string]: any } =
    (window as any).stemplateConfig || {};
  if (
    config.wxAuthUrl &&
    !user.openId &&
    isWeChat() &&
    config.weChatId &&
    config.weChatId != "0"
  ) {
    const hrefLink = window.location.href;
    let loginUrl = config.wxAuthUrl;
    let loadcount = parseInt(URLS.getURL("loadcount")) || 0;
    loadcount += 1;
    let zurl = URLS.removeSearchParam(
      hrefLink,
      "code",
      "appid",
      "loadcount",
      "retCode",
      "excode"
    );
    zurl = URLS.updateSearchParam("loadcount", loadcount, zurl);
    loginUrl = URLS.updateSearchParam(
      "return_url",
      encodeURIComponent(zurl),
      loginUrl
    );
    loginUrl = URLS.updateSearchParam("scope", "snsapi_base", loginUrl);
    if (loadcount < 4) {
      // alert("授权之前的跳转" + window.location.href);
      $sk.loading.show();
      window.location.href = loginUrl;
    }
  } else {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    // 删除名为 'param' 的参数
    searchParams.delete("code");
    searchParams.delete("appid");
    // searchParams.delete("loadcount");
    searchParams.delete("retCode");
    searchParams.delete("excode");
    searchParams.delete("scope");

    // 使用 history API 修改当前 URL
    history.replaceState(null, "", url.toString());
  }
}

$cz.setup("initUserEnd", () => {
  auth();
});
